// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sc-5";
export var filledCircle = "_sc-4";
export var historyEntry = "_sc-3";
export var messageSideLeft = "_sc-1";
export var messageSideRight = "_sc-2";
export var orderTrackingCarouselWrapper = "_sc-6";
export var orderTrackingInfoContainer = "_sc-0";